module.exports = __webpack_public_path__ + "static/media/slider-home-business-slide-01-image-03.80b2a6e2.png";